<template>
  <div data-component-group="layout" data-component="single-frame">
    <layout-logged-frame :has-nav="false" :has-aside="false">
      <template v-slot:content>
        <slot name="content" />
      </template>
    </layout-logged-frame>
  </div>
</template>

<style lang="scss">
@use '../../assets/styles/theme' as *;

[data-component-group='layout'] {
  &[data-component='single-frame'] {
    main {
      padding: $spacing-sm + 0.125rem 0 0 0 !important;

      .main-content {
        > div {
          max-width: 640px;
          margin: 0 auto;

          > .component-body {
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>
